import { render, staticRenderFns } from "./OfferHistory.vue?vue&type=template&id=ef47b2a4&scoped=true&"
import script from "./OfferHistory.vue?vue&type=script&lang=js&"
export * from "./OfferHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef47b2a4",
  null
  
)

export default component.exports